import { isUndefined, noop } from 'lodash/fp';
import React, { useMemo } from 'react';

import { useAppSelector } from '../../../../hooks/react-redux';
import { MinifiedRiskToleranceChart } from '../../../documents/analytics/charts/risk-tolerance/MinifiedRiskToleranceChart';
import { getAllDocumentsRiskTolerance } from '../../../documents/analytics/store/selectors';
import { DocumentAnalyticsChart } from '../../../documents/analytics/store/types';
import { ARROW_WIDTH_OFFSET } from '../../../shared/carousel/Carousel';

const TITLE_HEIGHT = 51;
const RISK_TOTAL_LABEL = 50;
const MODULE_PADDING = 20;

interface HomeRiskToleranceProps {
    dimensions?: {
        height: number;
        width: number;
    }
    shouldDoubleWidth: boolean;
}

export const HomeRiskTolerance: React.FC<HomeRiskToleranceProps> = ({ dimensions, shouldDoubleWidth }) => {
    const allDocumentsRiskTolerance = useAppSelector(getAllDocumentsRiskTolerance);
    const riskToleranceDimensions = useMemo(() => {
        if (isUndefined(dimensions)) {
            return { height: 0, width: 0 };
        }
        return { height: dimensions.height - (TITLE_HEIGHT + RISK_TOTAL_LABEL), width: ((dimensions.width / (shouldDoubleWidth ? 1 : 2)) - (ARROW_WIDTH_OFFSET + MODULE_PADDING)) };
    }, [dimensions, shouldDoubleWidth]);
    return (
        <MinifiedRiskToleranceChart tile={DocumentAnalyticsChart.DOCUMENT_RISK_TOLERANCE} tileInView={null} setTileInView={noop} allDocumentsRiskTolerance={allDocumentsRiskTolerance} dimensions={riskToleranceDimensions} showOverrideRiskRating hideFullScreen predefinedChartLabel='Risk Tolerance' />
    );
};
